const brand = process.env.BRAND || '';

const prefix = brand === 'meike' ? 'meike_' : '';

export const authorizationStorageKey = (activeBrand: string) =>
  `${activeBrand === 'meike' ? 'meike_' : ''}Authorization`;

export const Authorization = authorizationStorageKey(brand);
export const Token = `${prefix}token`;
export const UserInfo = `${prefix}userInfo`;

export type AuthorizationMode = 'department' | 'legacy';
